
import { useTranslation } from 'react-i18next';
import { CheckCircle, Users, Award, TrendingUp, Shield, Zap } from 'lucide-react';

export default function YonetimSistemleriPage() {
  const { t } = useTranslation();

  const isoStandards = [
    {
      code: '9001',
      title: t('services.yonetim.iso9001'),
      description: t('iso.9001.description'),
      benefits: [
        t('iso.9001.benefits.1'),
        t('iso.9001.benefits.2'),
        t('iso.9001.benefits.3'),
        t('iso.9001.benefits.4')
      ],
      icon: Award,
      color: 'bg-blue-500'
    },
    {
      code: '14001',
      title: t('services.yonetim.iso14001'),
      description: t('iso.14001.description'),
      benefits: [
        t('iso.14001.benefits.1'),
        t('iso.14001.benefits.2'),
        t('iso.14001.benefits.3'),
        t('iso.14001.benefits.4')
      ],
      icon: Shield,
      color: 'bg-green-500'
    },
    {
      code: '45001',
      title: t('services.yonetim.iso45001'),
      description: t('iso.45001.description'),
      benefits: [
        t('iso.45001.benefits.1'),
        t('iso.45001.benefits.2'),
        t('iso.45001.benefits.3'),
        t('iso.45001.benefits.4')
      ],
      icon: Shield,
      color: 'bg-red-500'
    },
    {
      code: '50001',
      title: t('services.yonetim.iso50001'),
      description: t('iso.50001.description'),
      benefits: [
        t('iso.50001.benefits.1'),
        t('iso.50001.benefits.2'),
        t('iso.50001.benefits.3'),
        t('iso.50001.benefits.4')
      ],
      icon: Zap,
      color: 'bg-yellow-500'
    },
    {
      code: '10002',
      title: t('services.yonetim.iso10002'),
      description: t('iso.10002.description'),
      benefits: [
        t('iso.10002.benefits.1'),
        t('iso.10002.benefits.2'),
        t('iso.10002.benefits.3'),
        t('iso.10002.benefits.4')
      ],
      icon: Users,
      color: 'bg-purple-500'
    },
    {
      code: '27001',
      title: t('services.yonetim.iso27001'),
      description: t('iso.27001.description'),
      benefits: [
        t('iso.27001.benefits.1'),
        t('iso.27001.benefits.2'),
        t('iso.27001.benefits.3'),
        t('iso.27001.benefits.4')
      ],
      icon: Shield,
      color: 'bg-indigo-500'
    },
    {
      code: '27701',
      title: t('services.yonetim.iso27701'),
      description: t('iso.27701.description'),
      benefits: [
        t('iso.27701.benefits.1'),
        t('iso.27701.benefits.2'),
        t('iso.27701.benefits.3'),
        t('iso.27701.benefits.4')
      ],
      icon: Shield,
      color: 'bg-pink-500'
    },
    {
      code: '31000',
      title: t('services.yonetim.iso31000'),
      description: t('iso.31000.description'),
      benefits: [
        t('iso.31000.benefits.1'),
        t('iso.31000.benefits.2'),
        t('iso.31000.benefits.3'),
        t('iso.31000.benefits.4')
      ],
      icon: TrendingUp,
      color: 'bg-orange-500'
    },
    {
      code: '39001',
      title: t('services.yonetim.iso39001'),
      description: t('iso.39001.description'),
      benefits: [
        t('iso.39001.benefits.1'),
        t('iso.39001.benefits.2'),
        t('iso.39001.benefits.3'),
        t('iso.39001.benefits.4')
      ],
      icon: Shield,
      color: 'bg-teal-500'
    },
    {
      code: '28001',
      title: t('services.yonetim.iso28001'),
      description: t('iso.28001.description'),
      benefits: [
        t('iso.28001.benefits.1'),
        t('iso.28001.benefits.2'),
        t('iso.28001.benefits.3'),
        t('iso.28001.benefits.4')
      ],
      icon: Shield,
      color: 'bg-cyan-500'
    },
    {
      code: '22301',
      title: t('services.yonetim.iso22301'),
      description: t('iso.22301.description'),
      benefits: [
        t('iso.22301.benefits.1'),
        t('iso.22301.benefits.2'),
        t('iso.22301.benefits.3'),
        t('iso.22301.benefits.4')
      ],
      icon: Shield,
      color: 'bg-emerald-500'
    }
  ];

  const implementationSteps = [
    {
      step: 1,
      title: t('implementation.step1.title'),
      description: t('implementation.step1.description')
    },
    {
      step: 2,
      title: t('implementation.step2.title'),
      description: t('implementation.step2.description')
    },
    {
      step: 3,
      title: t('implementation.step3.title'),
      description: t('implementation.step3.description')
    },
    {
      step: 4,
      title: t('implementation.step4.title'),
      description: t('implementation.step4.description')
    },
    {
      step: 5,
      title: t('implementation.step5.title'),
      description: t('implementation.step5.description')
    },
    {
      step: 6,
      title: t('implementation.step6.title'),
      description: t('implementation.step6.description')
    }
  ];

  const whyChooseISO = [
    {
      title: t('why.iso.recognition.title'),
      description: t('why.iso.recognition.description'),
      icon: Award
    },
    {
      title: t('why.iso.improvement.title'),
      description: t('why.iso.improvement.description'),
      icon: TrendingUp
    },
    {
      title: t('why.iso.risk.title'),
      description: t('why.iso.risk.description'),
      icon: Shield
    },
    {
      title: t('why.iso.trust.title'),
      description: t('why.iso.trust.description'),
      icon: Users
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section 
        className="relative py-24 bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/10c59b9f72775f9212bae1ae9b41aa41.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-blue-900/80"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              {t('iso.standards.title')}
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
              {t('iso.standards.subtitle')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-blue-900 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap">
                {t('cta.consultation')}
              </button>
              <button className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-900 transition-colors whitespace-nowrap">
                {t('cta.quote')}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ISO Standards Grid */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {t('services.yonetim.title')}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('services.yonetim.description')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {isoStandards.map((standard) => {
              const IconComponent = standard.icon;
              return (
                <div key={standard.code} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
                  <div className="flex items-center mb-4">
                    <div className={`${standard.color} p-3 rounded-lg mr-4`}>
                      <IconComponent className="h-6 w-6 text-white" />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900">ISO {standard.code}</h3>
                    </div>
                  </div>
                  
                  <h4 className="text-xl font-semibold text-gray-900 mb-3">
                    {standard.title}
                  </h4>
                  
                  <p className="text-gray-600 mb-4">
                    {standard.description}
                  </p>
                  
                  <div className="mb-6">
                    <h5 className="font-semibold text-gray-900 mb-2">{t('benefits.title')}</h5>
                    <ul className="space-y-2">
                      {standard.benefits.map((benefit, index) => (
                        <li key={index} className="flex items-start">
                          <CheckCircle className="h-5 w-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                          <span className="text-gray-600 text-sm">{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  <button className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap">
                    {t('common.learnMore')}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Implementation Process */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {t('implementation.title')}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('implementation.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {implementationSteps.map((step) => (
              <div key={step.step} className="relative">
                <div className="bg-blue-50 rounded-xl p-6 h-full">
                  <div className="flex items-center mb-4">
                    <div className="bg-blue-600 text-white rounded-full w-10 h-10 flex items-center justify-center font-bold mr-4">
                      {step.step}
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900">
                      {step.title}
                    </h3>
                  </div>
                  <p className="text-gray-600">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose ISO */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {t('why.iso.title')}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('why.iso.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {whyChooseISO.map((item, index) => {
              const IconComponent = item.icon;
              return (
                <div key={index} className="text-center">
                  <div className="bg-blue-600 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                    <IconComponent className="h-8 w-8 text-white" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-600">
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-blue-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('cta.iso.title')}
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            {t('cta.iso.description')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap">
              {t('cta.consultation')}
            </button>
            <button className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors whitespace-nowrap">
              {t('cta.quote')}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
